import React from 'react';
import { SalonProvider } from '../../contexts/SalonContext';
import { ServiceProvider } from '../../contexts/ServiceContext';
import BookingPage from './BookingPage';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

/**
 * Wrapper otimizado para a página de agendamento público
 * Não inclui os contextos UserContext e ProfessionalContext que são desnecessários para clientes
 * 
 * @param {Object} props - Propriedades do componente
 * @param {string} props.salonId - ID do salão
 * @returns {JSX.Element} - Componente renderizado
 */
const BookingWrapper = ({ salonId }) => {
  // Criar um QueryClient local para este componente
  // Isso evita que outras partes da aplicação interfiram com os dados
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutos
        cacheTime: 10 * 60 * 1000, // 10 minutos
        retry: 1
      }
    }
  });

  return (
    // Usar QueryClientProvider local para isolar as consultas deste fluxo
    <QueryClientProvider client={queryClient}>
      {/* Incluir apenas os contextos essenciais */}
      <SalonProvider salonId={salonId}>
        <ServiceProvider salonId={salonId}>
          <BookingPage />
        </ServiceProvider>
      </SalonProvider>
    </QueryClientProvider>
  );
};

export default BookingWrapper; 